import React from 'react';
import { FileText, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsOfUse = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-gray-300 py-20 px-6 pt-24">
      <div className="max-w-3xl mx-auto">
        <button 
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-[#4ade80] mb-8 hover:opacity-80 transition-opacity"
        >
          <ArrowLeft size={20} />
          Back
        </button>

        <div className="flex items-center gap-3 mb-6">
          <FileText className="text-[#4ade80]" size={32} />
          <h1 className="text-3xl font-bold text-white">Terms of Use</h1>
        </div>

        <div className="space-y-6 leading-relaxed">
          <p>Last Updated: May 12, 2026</p>
          
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Eligibility</h2>
            <p>You must be at least 13 years of age to use this site. Some specific offers may require you to be 18+ depending on the advertiser's requirements.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Rewards & Completion</h2>
            <p>Completion of offers does not guarantee a reward if the advertiser's tracking system fails to verify the completion. Using VPNs, proxies, or emulators is strictly prohibited and will result in disqualification.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Headquartered in NY</h2>
            <p>These terms are governed by the laws of the State of New York, USA. Any disputes shall be resolved in the courts of New York County.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Disclaimers</h2>
            <p>FreeBonusNow is a reward hub and not a direct provider of the games or services advertised. We are not responsible for third-party content or software.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;